import React from 'react';

const LoadingMenu = () => {
  // استایل‌های پایه برای جلوگیری از خطا
  //style.css .containermenuloading
  const containerStyle = {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center', // اگر می‌خواهی منو چپ‌چین باشد، این را به 'flex-start' تغییر بده
    alignItems: 'center',
    width: '100%',
    height: '48px',
    backgroundColor: '#fff', // رنگ پس‌زمینه سفید (یا رنگ منوی خودت)
  };

  // استایل مستطیل سمت چپ (لوگو یا عنوان)
  //style.css .leftboxmenuloading
  const leftBoxStyle = {
    position: 'absolute',
    top: '50%',
    left: '12%',
    transform: 'translate(-50%, -50%)',
    width: '120px', // عرض مستطیل چپ
    height: '40px', // ارتفاع مستطیل چپ
    backgroundColor: '#e0e0e0', // خاکستری
    borderRadius: '4px',
    animation: 'pulse .8s infinite ease-in-out',
  };

  // استایل کانتینر مستطیل‌های سمت راست
  //style.css .rightgroupmenuloading
  const rightGroupStyle = {
    position: 'absolute',
    top: '50%',
    right: '12%', // فاصله از راست
    transform: 'translateY(-50%)',
    display: 'flex',
    gap: '10px', // فاصله بین مستطیل‌ها
  };

  // استایل هر یک از ۵ مستطیل سمت راست
  //style.css .rightboxmenuloading
  const rightBoxStyle = {
    width: '110px', // عرض مستطیل‌های راست
    height: '30px', // ارتفاع مستطیل‌های راست
    backgroundColor: '#e7e7e7',
    borderRadius: '3px',
    animation: 'pulse .8s infinite ease-in-out',
  };

  return (
    <div style={containerStyle}>
      {/* مستطیل سمت چپ */}
      <div style={leftBoxStyle}></div>

      {/* ۵ مستطیل سمت راست */}
      <div style={rightGroupStyle}>
        {[...Array(5)].map((_, index) => (
          <div key={index} style={rightBoxStyle}></div>
        ))}
      </div>
    </div>
  );
};

export default LoadingMenu;
